import t from"react";import{MdIcon as r}from"./MdIcon.js";import{mdiTrashCanOutline as o}from"@mdi/js";const e=({id:e="trash-can",title:i="Trash can",...m})=>t.createElement(r,{id:e,title:i,path:o,...m});export{e as TrashCanOutlineIcon};
